import { actions, selectors, useDispatch, useSelector } from '@sloyd/store-base';
import { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useUnmount } from 'react-use';
import { $a, $ac } from 'shared-base';
import { Editor } from '../components/Editor/Editor';
import { EditorActionsContainer } from '../components/EditorActions/EditorActions.container';
import EditorCommandsQueueContainer from '../components/EditorCommandsQueue/EditorCommandsQueue.container';
import ExitRealtimeContainer from '../components/ExitRealtime/ExitRealtime.container';
import SceneBuilderContainer from '../components/SceneBuilder/SceneBuilder.container';
import SubtitlesContainer from '../components/Subtitles/Subtitles.container';
import EditorModeContainer from './EditorMode.container';
import ExplanationContainer from './Explanation.container';
import HolodeckContainer from './Holodeck.container';
import { LoaderBarContainer } from './LoaderBar.container';
import LodContainer from './Lod.container';
import { ObjectBarContainer } from './ObjectBar.container';
import PrompterContainer from './Prompter.container';

export type EditorContainerProps = {};

export function EditorContainer(_props: EditorContainerProps) {
  const dispatch = useDispatch();
  const focusMode = useSelector(selectors.base.$focusMode);
  const holodeck = useSelector(selectors.raw.$rawHolodeckState);
  const settings = useSelector(selectors.raw.$rawSettings);
  const { projectId, modelId } = useParams();
  const { unityVersion } = settings;

  useEffect(() => {
    dispatch($a('HOLODECK', 'bootstrap'));
  }, []);

  useEffect(() => {
    dispatch(actions.currentIds.patch({ projectId }));
    dispatch($a('PROJECTS', 'load', projectId));
  }, [projectId]);

  useEffect(() => {
    dispatch(actions.currentIds.patch({ modelId }));
  }, [modelId]);

  useUnmount(() => {
    dispatch(actions.currentIds.patch({ projectId: '', modelId: '' }));
  });

  const callbacks = useMemo(
    () => ({
      onReady: () => {
        dispatch($ac('UNITY_READY'));
        dispatch(actions.appState.patch({ isUnityReady: true }));
        dispatch($a('GUIDANCE', 'bootstrap'));
      },
    }),
    []
  );

  return (
    <Editor
      focusMode={focusMode}
      holodeck={holodeck}
      unityVersion={unityVersion}
      callbacks={callbacks}
      main={<PrompterContainer />}
      right={<ObjectBarContainer />}
    >
      <ExplanationContainer />
      <LoaderBarContainer />
      <EditorActionsContainer />
      <HolodeckContainer instanceId='main' />
      <LodContainer instanceId='main' />
      <EditorModeContainer />
      <SceneBuilderContainer />
      <ExitRealtimeContainer />
      <EditorCommandsQueueContainer />
      <SubtitlesContainer />
    </Editor>
  );
}

export default EditorContainer;
